import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const BedType = ({ bed }: SpecProps<"bed">) => {
  const { i18n } = useLingui();

  if (!bed) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.bed_type",
    message: "Type of bed",
    comment: "Field for 'bed type' in ad specification",
  });
  return <FieldValuePair field={field} value={bed} />;
};
